import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-navy-900 text-white">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          {/* Brand column */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
                <img src="/mato_logo_black.svg" alt="Mato Industries Logo" className="h-9 w-auto brightness-0 invert" width="36" height="36" />
              <div>
                <div className="font-bold text-base leading-tight">Mato Industries</div>
                <div className="text-slate-500 text-xs tracking-widest uppercase">Est. 1968</div>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
              ISO 9001:2015 certified manufacturer of Bronze Bushings, Thrust Washers, and precision copper alloy components. Tier-1 supplier to global OEMs since 1968.
            </p>
            <div className="flex gap-3 mt-5">
              <span className="px-3 py-1 bg-white/5 border border-white/10 rounded-full text-xs text-slate-400">ISO 9001:2015</span>
              <span className="px-3 py-1 bg-white/5 border border-white/10 rounded-full text-xs text-slate-400">ISO 45001:2018</span>
              <span className="px-3 py-1 bg-white/5 border border-white/10 rounded-full text-xs text-slate-400">ISO 14001:2015</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {[
                { to: '/about', label: 'About Us' },
                { to: '/products', label: 'Products' },
                { to: '/infrastructure', label: 'Infrastructure' },
                { to: '/contact', label: 'Contact Us' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-slate-400 hover:text-brand-400 text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Get in Touch</h4>
            <div className="space-y-3">
              <div>
                <a
                  href="tel:+919910934449"
                  className="text-slate-400 hover:text-brand-400 text-sm transition-colors duration-200 cursor-pointer block"
                >
                  +91-9910934449
                </a>
              </div>
              <div>
                <a
                  href="mailto:sales@matoindustries.com"
                  className="text-slate-400 hover:text-brand-400 text-sm transition-colors duration-200 cursor-pointer block"
                >
                  sales@matoindustries.com
                </a>
              </div>
              <div className="text-slate-500 text-sm leading-relaxed pt-1">
                A-5, G.T. Karnal Road<br />
                Industrial Area,<br />
                Delhi – 110033, India
              </div>
            </div>
          </div>

        </div>

        <div className="mt-10 pt-6 border-t border-white/8 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-slate-500 text-xs">© 2026 Mato Industries. All rights reserved.</p>
          <p className="text-slate-600 text-xs">Precision Manufacturing Since 1968</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
